import React from 'react';

const UserReferralPlanFormModal = React.lazy(() => import('../components/FormModal'));
const userReferralPlanModalRegistry = {
    core_userReferralPlanId: UserReferralPlanFormModal
};
export default userReferralPlanModalRegistry;
